import React from 'react';

import PropTypes from 'prop-types';
import { Image, useComputedColorScheme } from '@mantine/core';

import logoConfig from 'config/logos';

const SIZE_TOKENS = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40,
  '2xl': 56,
};

export default function MarketplacePosLogo({ source = 'chownow', variant = 'ink', size = 'md' }) {
  const colorScheme = useComputedColorScheme('light');
  // ink sits on themed surfaces, so it flips to white once those go dark
  const resolvedVariant = variant === 'ink' && colorScheme === 'dark' ? 'white' : variant;
  const logoType = logoConfig[source]?.type;
  const Logo = logoConfig[source]?.[resolvedVariant] ?? null;
  // a number sizes the logo directly (px); named tokens map to the scale above
  const dimension = typeof size === 'number' ? `${size}px` : `${SIZE_TOKENS[size] ?? 24}px`;

  return (
    !!Logo &&
    (logoType === 'png' ? (
      <Image src={Logo} h={dimension} w={dimension} fit="contain" />
    ) : (
      <Logo height={dimension} width={dimension} />
    ))
  );
}

MarketplacePosLogo.propTypes = {
  source: PropTypes.string,
  variant: PropTypes.oneOf(['color', 'ink', 'white']),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
